import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

const mapVehicleTypeResponse = (item = {}) => ({
  ...item,
  vhtId: item.vhtId ?? item.vetId ?? null,
  vetId: item.vetId ?? item.vhtId ?? null,
  vhtMaxCbm: item.vhtMaxCbm ?? "",
  vhtMaxCbf: item.vhtMaxCbf ?? "",
  vhtCategory: item.vhtCategory ?? "",
  vhtCompany: item.vhtCompany ?? null,
  vhtLoadingTime: item.vhtLoadingTime ?? "",
  vhtUnloadingTime: item.vhtUnloadingTime ?? "",
});

const mapVehicleTypeRequest = (data = {}) => ({
  vetId: data.vetId ?? data.vhtId ?? null,
  vetCode: data.vetCode ?? null,
  vhtType: data.vhtType ?? "",
  vhtDescription: data.vhtDescription ?? "",
  vhtMaxCbf: data.vhtMaxCbf ?? null,
  vhtMaxCbm: data.vhtMaxCbm ?? null,
  vhtCarbonFactor: data.vhtCarbonFactor ?? null,
  vhtDemurrage: data.vhtDemurrage ?? null,
  vhtLoadingTime: data.vhtLoadingTime ?? null,
  vhtUnloadingTime: data.vhtUnloadingTime ?? null,
  vhtCategory: data.vhtCategory ?? null,
  vhtCompany: data.vhtCompany ?? null,
  vhtSeq: data.vhtSeq ?? null,
  vhtStatus: data.vhtStatus ?? null,
  vhtActive: data.vhtActive ?? null,
  author: data.author ?? data.createdBy ?? data.lastModifiedBy ?? null,
});

export const vehicleTypeDropdown = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/vehicletype`,
    );

    return response.data.map((item) => ({
      key: item.vetId,
      text: item.vhtDescription || item.vhtType,
      value: item.vetId,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const createVehicleType = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/vehicletype`,
    mapVehicleTypeRequest(data),
  );
  return response.data;
};

export const updateVehicleType = async (data) => {
  const response = await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/vehicletype`,
    mapVehicleTypeRequest(data),
  );
  return response.data;
};

export const searchVehicleTypes = async (params) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/vehicletype/search`,
    params,
  );

  return (response.data || []).map(mapVehicleTypeResponse);
};

export const getVehicleTypeById = async (id) => {
  const response = await gatewayInstance.get(
    `${SERVICE_ENDPOINT.TRANSPORT}/vehicletype/${id}`,
  );

  return mapVehicleTypeResponse(response.data);
};
